mutation updateCompanyCustomWording($input: UpdateCompanyCustomWordingInput!) {
  updateCompanyCustomWording(input: $input) {
    id
    customWording {
      salutation
      farewell
    }
  }
}
